import { useCallback, useEffect, useState } from "react";
import client from "@/lib/api";
import { CurrencyEur, Users, ClipboardText, Buildings } from "@phosphor-icons/react";

const Card = ({ label, value, icon: Icon, accent, testId }) => (
  <div className="bg-white border border-[#E5E7EB] rounded-md p-5" data-testid={testId}>
    <div className="flex items-center justify-between mb-3">
      <div className={`w-9 h-9 rounded-sm flex items-center justify-center ${accent}`}>
        <Icon size={18} weight="duotone" />
      </div>
      <div className="text-[10px] uppercase tracking-[0.2em] text-[#64748B]">{label}</div>
    </div>
    <div className="trent-heading text-3xl font-black tracking-tighter text-[#0F172A]">{value}</div>
  </div>
);

export default function AdminOverview() {
  const [stats, setStats] = useState(null);
  const load = useCallback(() => client.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);

  return (
    <div data-testid="admin-overview">
      <div className="text-[11px] uppercase tracking-[0.3em] text-[#64748B] mb-1">Admin</div>
      <h1 className="trent-heading text-3xl md:text-4xl font-black tracking-tighter text-[#0F172A] mb-8">
        Platform overview
      </h1>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        <Card icon={Users} label="Users" value={stats?.total_users ?? "—"} accent="bg-[#DBEAFE] text-[#1E40AF]" testId="stat-users" />
        <Card icon={CurrencyEur} label="MRR (estimated)" value={stats ? `€${stats.mrr_eur}` : "—"} accent="bg-[#D1FAE5] text-[#065F46]" testId="stat-mrr" />
        <Card icon={Buildings} label="Properties" value={stats?.total_properties ?? "—"} accent="bg-[#E0F2FE] text-[#0369A1]" testId="stat-properties" />
        <Card icon={ClipboardText} label="Inspections" value={stats?.total_inspections ?? "—"} accent="bg-[#DCFCE7] text-[#14532D]" testId="stat-inspections" />
        <Card icon={ClipboardText} label="Completed" value={stats?.completed_inspections ?? "—"} accent="bg-[#FEF3C7] text-[#92400E]" testId="stat-completed" />
      </div>

      {stats?.by_plan && (
        <div className="mt-8 bg-white border border-[#E5E7EB] rounded-md p-6">
          <div className="text-[10px] uppercase tracking-[0.25em] text-[#64748B] font-semibold mb-3">
            Plan distribution
          </div>
          <div className="grid sm:grid-cols-3 gap-4">
            {Object.entries(stats.by_plan).map(([plan, count]) => (
              <div key={plan} className="border border-[#E5E7EB] rounded-md p-4">
                <div className="text-xs uppercase tracking-wider text-[#64748B]">{plan}</div>
                <div className="trent-heading text-2xl font-black text-[#0F172A] mt-1">{count}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
